<script>
		import { user, send_data } from "../client.svelte.js";
		import { narrate, taleStates, fellow_name } from "./_Narrate.svelte";

		let tale = $derived(user.tales.get(narrate.taleID))
		let state = $derived(taleStates[tale?.state] ?? taleStates[0])
		let isMaster = $derived(tale?.master === user.ID)

		function change_notes(e) {
				send_data(`/tale/${tale.ID}`, {notes: e.target.value}, 'PATCH')
		}
</script>


<!-------------------------------- HTML -------------------------------------->

<article class="tale">
	{#if tale}
		<div class="statCards">
			<div class="card">
				<span class="card-kicker">Erhaltene EP</span>
				<span class="statValue">{tale.XP ?? 0}</span>
			</div>
			<div class="card">
				<span class="card-kicker">Region</span>
				<span class="statText">{tale.region || "–"}</span>
				{#if tale.campaigne}<span class="card-meta">{tale.campaigne}</span>{/if}
			</div>
			<div class="card">
				<span class="card-kicker">Meister</span>
				<span class="statText">{fellow_name(tale.master)}</span>
				<span><span class="tag {state.tag}">{state.label}</span></span>
			</div>
		</div>

		<div class="columns">
			<section class="summary" data-help="summary">
				<h3 class="card-title">Zusammenfassung</h3>
				<p>{tale.summary || "Noch keine Zusammenfassung vorhanden."}</p>
			</section>
			<section class="card times" data-help="times">
				<h3 class="card-title">Zeit</h3>
				<div>
					<h4 class="card-kicker">Spielzeit (Beginn)</h4>
					<div>{tale.start || "–"}</div>
				</div>
				<div>
					<h4 class="card-kicker">Dauer (Spielzeit)</h4>
					<div>{tale.duration || "–"}</div>
				</div>
				<div>
					<h4 class="card-kicker">Realzeit</h4>
					<div>{tale.realtime || "–"}</div>
				</div>
			</section>
		</div>

		{#if isMaster}
			<section class="card notes" data-help="notes">
				<div class="cardTitleRow">
					<h3 class="card-title">Notizen</h3>
					<span class="tag accent"><span class="fa icon-lock"></span> nur für den Meister sichtbar</span>
				</div>
				<div class="field">
					<textarea rows="5" value={tale.notes ?? ""} onchange={change_notes}></textarea>
				</div>
			</section>
		{/if}
	{:else}
		<p class="card-meta">Bitte wähle zuerst ein Abenteuer aus der Liste der gespielten Abenteuer aus.</p>
	{/if}
</article>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.tale
		max-width: 1048px

	.statCards
		display: grid
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))
		gap: 14px
		margin-bottom: 18px

		.card
			gap: 6px

	.statValue
		font-size: 26px
		font-weight: bold

	.statText
		font-size: 17px
		font-weight: bold

	.columns
		display: flex
		flex-wrap: wrap
		gap: 24px 36px
		align-items: flex-start

	.summary
		flex: 2 1 420px
		min-width: 0

		p
			max-width: 68ch
			margin-top: 8px
			line-height: 1.5
			color: colors.$grey-85
			white-space: pre-line

	.times
		flex: 1 1 260px

		h4
			margin-bottom: 2px

	.notes
		margin-top: 18px
		background: colors.$primary-040-black
		border-color: colors.$primary-060-black

		.fa
			filter: none
			font-size: 10px

		textarea
			background: colors.$black
</style>
